import { render, staticRenderFns } from "./SeminarDashboard.vue?vue&type=template&id=e1eec4b8"
import script from "./SeminarDashboard.vue?vue&type=script&lang=js"
export * from "./SeminarDashboard.vue?vue&type=script&lang=js"
import style0 from "./SeminarDashboard.vue?vue&type=style&index=0&id=e1eec4b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports